export function EmployeeReferralProgramCarousel(props: any) {
    //console.log(props + "props.url");
    //console.log("EmployeeReferralProgramCarousel props:", props);
    return (
        <div className="card border-0 mb-0 pb-0">
            <a href={props.is_url} target="_blank" rel="noopener noreferrer">
                <img
                    src={props.web_url}
                    className="w-100 img-fluid desktopImage"
                    alt="Employee Referral Program"
                />
                </a>
                <a href={props.is_url} target={"_blank"} rel="noopener noreferrer">
                        
                <img
                    src={props.mobile_url}
                    className="w-100 img-fluid mobileImage"
                    alt="Employee Referral Program"
                />
            </a>
        </div>
    );
}

            {/*{(props.countryName === "BG" ||
                props.countryName === "GR" ||
                props.countryName === "IE" ||
                props.countryName === "PL" ||
                props.countryName === "UK") &&
                (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://linktr.ee/ttecreferralEMEA"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://linktr.ee/ttecreferralEMEA"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )}
            {
                (props.countryName === "US" || props.countryName === "CA") && (

                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://linktr.ee/TTECReferral"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://linktr.ee/TTECReferral"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )
            }
            {
                props.countryName === "MX" && (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://linktr.ee/TTECmx"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://linktr.ee/TTECmx"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )
            }
            {
                props.countryName === "PH" && (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://teletechinc.sharepoint.com/teams/Employee_Referral_Program/SitePages/Philippines.aspx"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://teletechinc.sharepoint.com/teams/Employee_Referral_Program/SitePages/Philippines.aspx"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )
            }
            {
                props.countryName === "CO" && (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://linktr.ee/TTEC_Colombia"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://linktr.ee/TTEC_Colombia"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )
            }
            {
                props.countryName === "BR" && (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://linktr.ee/TTECbr"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://linktr.ee/TTECbr"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>
                )
            }
            {
                props.countryName === "AU" && (
                    <div className="card border-0 mb-0 pb-0">
                        <a
                            href="https://forms.office.com/Pages/ResponsePage.aspx?id=UJpcXVTIo06wXRY4ixTVs6n2n0y1UthMlSgAfOM8HGRURU0xMExJSVhVT1lZMDBSRFpKTEZESFBQTSQlQCN0PWcu"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.web_url}
                                className="w-100 img-fluid desktopImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                        <a
                            href="https://forms.office.com/Pages/ResponsePage.aspx?id=UJpcXVTIo06wXRY4ixTVs6n2n0y1UthMlSgAfOM8HGRURU0xMExJSVhVT1lZMDBSRFpKTEZESFBQTSQlQCN0PWcu"
                            target={"_blank"}
                            rel="noreferrer"
                        >
                            <img
                                src={props.mobile_url}
                                className="w-100 img-fluid mobileImage"
                                alt="Employee Referral Program"
                            />
                        </a>
                    </div>


                )

            }
        */}
       

